import _extends from '@babel/runtime-corejs3/helpers/extends';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _indexOfInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/index-of';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import React__default from 'react';
import classNames from 'classnames';
import styles from './d0f4ef905db6ff4aa2210fbf8d7198de6be0f13a621b3369ac7134651a7e3c08.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useMouseDrag from './1d9bcf479e72a70c11fcd2306ff36b98461a7fe5f14abf422485065811b273a9.cfe-internal.js';
import isMouseEvent from './66b37a2abed4dca8cbef48429ea491e6e8570c21830757dbc1f59911ce63829b.cfe-internal.js';
import useEventCallback from '../../hooks/useEventCallback/0ebce52fac2aa94b4cad29a85740b8586bddbccb9acd7c8786ebbfef7b665ae0.cfe-internal.js';

var _excluded = ["hsb", "onChange", "className"];
var getMouseChange = function getMouseChange(e, hsb, container) {
  var containerHeight = container.clientHeight;
  var y = isMouseEvent(e) ? e.pageY : e.touches[0].pageY;
  var bottom = container.getBoundingClientRect().bottom + window.pageYOffset - y;
  var h;
  if (bottom < 0) {
    h = 0;
  } else if (bottom > containerHeight) {
    h = 360;
  } else {
    var percent = bottom / containerHeight;
    h = 360 * percent;
  }
  return {
    h: Math.round(h),
    s: hsb.s,
    b: hsb.b,
    a: hsb.a
  };
};
var KEY_CHANGES = {
  ArrowUp: 4,
  ArrowDown: -4
};
var getKeyChange = function getKeyChange(e, hsb) {
  var hueChange = KEY_CHANGES[e.key];
  var h = Math.max(0, Math.min(360, hsb.h + hueChange));
  return {
    h: h,
    s: hsb.s,
    b: hsb.b,
    a: hsb.a
  };
};
var Hue = function Hue(_ref) {
  var hsb = _ref.hsb,
    onChange = _ref.onChange,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var containerRef = React__default.useRef(null);
  var handleChange = useEventCallback(function (e) {
    var change = getMouseChange(e, hsb, containerRef.current);
    onChange === null || onChange === void 0 || onChange(change, e);
  });
  var handleMouseDown = useMouseDrag(handleChange);
  function handleKeyDown(e) {
    var _context;
    if (_indexOfInstanceProperty(_context = _Object$keys(KEY_CHANGES)).call(_context, e.key) > -1) {
      var change = getKeyChange(e, hsb);
      onChange === null || onChange === void 0 || onChange(change, e);
    }
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", _extends({}, rest, {
      ref: containerRef,
      className: classNames(styles.hue, className),
      onMouseDown: handleMouseDown,
      onKeyDown: handleKeyDown,
      onTouchMove: handleChange,
      onTouchStart: handleChange,
      role: "slider",
      "aria-valuemin": 0,
      "aria-valuemax": 360,
      "aria-valuenow": hsb.h,
      tabIndex: 0
    }), /*#__PURE__*/React__default.createElement("div", {
      className: styles.hueSlider,
      style: {
        bottom: "".concat(hsb.h / 360 * 100, "%")
      }
    }))
  );
};

export { Hue as default };
